// PayPal hosted checkout (No-Code Payment) link.
// Clicking any Buy button redirects here to PayPal's secure hosted checkout.
export const PAYPAL_PAYMENT_LINK = "https://www.paypal.com/ncp/payment/XQFMNRZAA6EFL";

// Safe GA4 event helper — no-op if gtag isn't loaded yet.
export function trackEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

export function startCheckout() {
  // Fire GA4 checkout-start / purchase-intent conversion before redirecting to PayPal.
  trackEvent("begin_checkout", {
    currency: "USD",
    value: 27.0,
    items: [
      {
        item_id: "FACELESS-BUNDLE-11",
        item_name: "The Faceless Marketing Bundle",
        price: 27.0,
        quantity: 1,
      },
    ],
  });
  window.location.href = PAYPAL_PAYMENT_LINK;
}
